import { useLocation } from "react-router-dom";
import { Icon } from "./icons";
import { Chat } from "./Chat";
import { areaForPath } from "./suite";
import { usePageChat } from "./pageChat";

// Courage Chat in a side panel, available on every page; it scopes to the area you're in, and to what the page has
// open when the page says (a process map, for one).
export function CourageChat({ onClose }: { onClose: () => void }) {
  const loc = useLocation();
  const area = areaForPath(loc.pathname);
  const page = usePageChat();
  return (
    <aside className="copilot" aria-label="Courage Chat">
      <div className="head">
        <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M8 1l1.6 4.4L14 7l-4.4 1.6L8 13l-1.6-4.4L2 7l4.4-1.6z" fill="#0A7C8C" /></svg>
        Courage Chat
        <span style={{ flex: 1 }} />
        <button className="icon-btn" aria-label="Close" onClick={onClose} style={{ border: 0 }}><Icon name="close" size={14} /></button>
      </div>
      <div className="body"><Chat key={page?.context ?? "area"} area={area?.id} compact context={page?.context} placeholder={page?.placeholder} prompts={page?.prompts} beforeConfirm={page?.beforeConfirm} onChanged={page?.onChanged} /></div>
    </aside>
  );
}
